// 手机号验证
export function valiPhone(phone) {
  if (/^1\d{10}$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 中文姓名
export function valiName(phone) {
  if (/^(?:[\u4e00-\u9fa5·]+)$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 邮政编码认证
export function postalCode(val) {
  let reg = /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 车牌号验证
export function valiCarNumber(val) {
  let reg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 数字验证，带长度验证，不传代表不限长度
export function valiNum(val, num) {
  let reg = num ? new RegExp('^([0-9]{0,' + num + '})$', 'g') : new RegExp('^([0-9]{0,})$');
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 数字+字母验证，带长度验证，不传代表不限长度，考虑纯数字纯字母
export function valiNumLetter(val, num) {
  // (?![0-9]+$)(?![a-zA-Z]+$)
  let reg = num
    ? new RegExp('^([0-9a-zA-Z]{0,' + num + '})$', 'g')
    : new RegExp('^([0-9a-zA-Z]{0,})$');
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}
